/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Component,
  OnChanges,
  Input,
  ViewEncapsulation,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { SubEventsService } from 'src/app/shared/services/data-api/sub-events.service';
import { ScoreEventsService } from 'src/app/shared/services/data-api/score-events.service';
import {
  TopEventsParamsService,
  TopEventsTarget,
} from 'src/app/shared/utils/top-events-params.service';
import { TopEventsResponse } from 'src/app/shared/models/score-events.interface';
import { Observable } from 'rxjs';
import { EntityInfoService } from 'src/app/shared/services/metadata-api/entity-info.service';
import { RoutingService } from 'src/app/service/routing.service';
import { ConfigService } from 'src/app/service/config.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PortfolioNameComponent } from '../news-portfolio/portfolio-name/portfolio-name.component';
import { QueryNameComponent } from '../news-query/query-name/query-name.component';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ColorPipe } from '../../../pipe/color.pipe';
import { NewsScoreStateService } from '../news-score-state.service';
import { ScoreUtilsService } from 'src/app/shared/utils/score-utils.service';
import { ColorScorePipe } from '../../../pipe/color-score.pipe';
import { ColorScore2Pipe } from '../../../pipe/color-score2.pipe';
import { DialogTableComponent } from '../../../micro-components/dialog-table/dialog-table.component';
import getScoreTypeDetails from 'src/app/shared/utils/score-type-details';
import { ScoreFocusedEventsService } from '../news-chartmap/score-focused-events.service';
import { ReportStateService } from 'src/app/shared/services/report-state.service';
import { DateUtils } from 'src/app/shared/utils/date.utils';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-title',
  templateUrl: './news-title.component.html',
  styleUrls: ['./news-title.component.scss'],
})
export class NewsTitleComponent implements OnChanges {
  @Input() titolo: any;
  params: any;
  previousValue: any;
  folios: any;
  folio: any;
  query: any;
  id: string;
  label: string;
  period: number;
  showWarningFlag = false;
  showCautionFlag = false;
  flagScore: number;
  industryBenchmarkScore = null;
  industryBenchmarkDescription = '';
  alertScoreType = null;
  alertScoreValue = null;
  alertEvents = null;
  alertEventsCount = null;
  alertEventsTimeframe = null;
  scoreEvents = null;
  scoreEventsCount = null;
  scoreEventsTimeframe = null;
  flagWarningEvents = null;
  flagWarningEventsCount = null;
  flagWarningEventsTimeframe = null;
  flagCautionEvents = null;
  flagCautionEventsCount = null;
  flagCautionEventsTimeframe = null;

  mouseOverCautionFlag = false;
  mouseOverWarningFlag = false;
  mouseOverIndustryBench = false;
  mouseOverScore = false;
  mouseOverAlert = false;
  isScoreFocused = true;
  isLoadingEvents: boolean = false;

  entities = [];
  queries = [];

  /**
   * color theme
   */

  theme = 'dark';

  // llm chart visualization

  customScore: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    public userState: UserStateService,
    private yukkApi: YukkApi,
    private subEvents: SubEventsService,
    private scoreEventsService: ScoreEventsService,
    private topEventsParams: TopEventsParamsService,
    private entityInfoService: EntityInfoService,
    public routing: RoutingService,
    public config: ConfigService,
    public dialog: MatDialog,
    private colorpipe: ColorPipe,
    private colorpipeScore: ColorScorePipe,
    private colorpipeScore2: ColorScore2Pipe,
    private newsScoreState: NewsScoreStateService,
    private scoreFocusedEventsService: ScoreFocusedEventsService,
    public reportStateService: ReportStateService,
    private portfolioApi: PortfolioApiService,
  ) {
    this.customScore = this.auth.scorelabSettings.defaultScore;
    this.alertScoreType = null;

    this.route.queryParams.subscribe((params) => {
      this.params = params;
      this.period = params.period ? params.period : 7;

      this.customScore = this.auth.scorelabSettings.defaultScore;
      this.theme = this.routing.theme;

      if (
        routing.reFresh(params, this.previousValue, [
          'id',
          'groupId',
          'portfolioId',
        ])
      ) {
        if (routing.isFolio()) {
          if (this.portfolioApi.portfolios) {
            const portfolioId = params.portfolioId
              ? params.portfolioId
              : params.id;
            this.folio = this.portfolioApi.portfolios.filter((el) => {
              return el.uid === portfolioId;
            })[0];
            const entities = this.folio.content;
            this.entityInfoService
              .getEntitiesInfo(entities)
              .subscribe((result) => {
                this.entities = Object.values(result).filter((element) => {
                  return element !== null;
                });
                this.entities.forEach((item) => {
                  item.name =
                    item.name !== 'PNE'
                      ? item.name
                      : item.alpha_id.split('.')[1] +
                        ' (' +
                        item.alpha_id.split('.')[0] +
                        ')';
                });
              });
          } else {
            this.entities = [];
          }
        }

        if (routing.isQuery()) {
          if (this.auth.querys) {
            const collectionId = params.groupId;
            this.query = this.auth.querys.filter((el) => {
              return el.uid === collectionId;
            })[0];
            this.queries = this.query.content;
          } else {
            this.queries = [];
          }
        }
      }

      if (routing.reFresh(params, this.previousValue, ['updateFlag'])) {
        this.checkWarningFlag();
        this.checkCautionFlag();
      }

      if (
        routing.reFresh(params, this.previousValue, ['focused_score', 'score'])
      ) {
        const scoreParam =
          params.focused_score || (params.alert_id ? params.score : null);

        if (scoreParam && this.customScore !== scoreParam) {
          const normalizedScore = getScoreTypeDetails(scoreParam).scoreKey;
          const normalizedCustomScore = getScoreTypeDetails(
            this.customScore,
          ).scoreKey;

          if (normalizedScore && normalizedCustomScore !== normalizedScore) {
            this.alertScoreType = normalizedScore;
          }
        }
      }

      this.previousValue = params;
    });
  }

  getSentimentColor(value: number): string {
    return this.colorpipe.transform(value);
  }

  getTypedScoreColor(score: number, scoreType: string): string {
    if (this.auth.getScoreType(scoreType) === 'pos') {
      return this.colorpipeScore2.transform(score);
    }
    return this.colorpipeScore.transform(score);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['titolo']) {
      const previousValue = changes['titolo'].previousValue;
      const currentValue = changes['titolo'].currentValue;

      // Execute logic if the value has actually changed (including first load)
      if (JSON.stringify(previousValue) !== JSON.stringify(currentValue)) {
        this.executeOnChanges();
      }
    }
  }

  executeOnChanges() {
    this.isLoadingEvents = true;

    if (this.titolo) {
      this.reportStateService.checkStatuses({
        mode: 'entity',
        entity: this.titolo.entity,
        folio: this.folio,
        customScore: this.customScore,
      });
    }

    this.scoreEventsCount = null;
    this.scoreEventsTimeframe = null;
    this.flagWarningEventsCount = null;
    this.flagWarningEventsTimeframe = null;
    this.flagCautionEventsCount = null;
    this.flagCautionEventsTimeframe = null;
    if (!this.params.score) {
      this.isScoreFocused = false;
    }
    if (this.alertScoreType && this.customScore === this.alertScoreType) {
      this.alertScoreType = null;
    }

    this.checkWarningFlag();
    this.checkCautionFlag();
    this.getIndustryBenchmark();
    this.getScoreEvents();
    this.getScore();

    if (this.titolo && this.params.type && this.params.type === 'pne') {
      this.titolo.entity.name =
        this.titolo.entity.alpha_id.split('.')[1] +
        ' (' +
        this.titolo.entity.alpha_id.split('.')[0] +
        ')';
    } else if (
      this.auth &&
      this.portfolioApi.activePortfolio &&
      this.portfolioApi.activePortfolio.marketPortfolio &&
      this.titolo &&
      this.params.type &&
      ['industry', 'supersector', 'sector', 'subsector'].includes(
        this.params.type,
      )
    ) {
      this.titolo.entity.type = this.params.type;
      this.titolo.entity.name =
        this.portfolioApi.activePortfolio.marketPortfolioName;
    }

    if (
      this.titolo &&
      this.params &&
      this.params.focused_score &&
      this.params.focused_score === this.customScore
    ) {
      let scoreColor = 'transparent';
      if (
        this.params.focused_score === 'sentiment' &&
        this.titolo.sentiment?.sentiment
      ) {
        scoreColor = this.colorpipe.transform(this.titolo.sentiment.sentiment);
      } else if (
        ['bb'].includes(this.params.focused_score) &&
        this.titolo.trend_type
      ) {
        scoreColor = this.titolo.trend_type === 'bear' ? '#dd001a' : '#1e816c';
      } else if (
        this.titolo.score &&
        this.auth.getScoreType(this.params.focused_score) === 'pos'
      ) {
        scoreColor = this.colorpipeScore2.transform(this.titolo.score);
      } else if (this.titolo.score) {
        scoreColor = this.colorpipeScore.transform(this.titolo.score);
      }
      const timeframe =
        this.params.focused_score !== 'sentiment'
          ? this.checkFocusedTimeframe(this.params.time, 100)
          : this.params.time
            ? DateUtils.fromTo(this.params.time).period
            : 7;
      Promise.resolve().then(() => {
        this.onScoreFocus(
          'score',
          this.params.focused_score,
          timeframe,
          scoreColor,
          false,
        );
      });
    } else if (
      this.titolo &&
      this.params &&
      this.params.score &&
      this.params.score === this.customScore
    ) {
      let scoreColor = 'transparent';
      if (
        this.params.score === 'sentiment' &&
        this.titolo.sentiment?.sentiment
      ) {
        scoreColor = this.colorpipe.transform(this.titolo.sentiment.sentiment);
      } else if (['bb'].includes(this.params.score) && this.titolo.trend_type) {
        scoreColor = this.titolo.trend_type === 'bear' ? '#dd001a' : '#1e816c';
      } else if (
        this.titolo.score &&
        this.auth.getScoreType(this.params.score) === 'pos'
      ) {
        scoreColor = this.colorpipeScore2.transform(this.titolo.score);
      } else if (this.titolo.score) {
        scoreColor = this.colorpipeScore.transform(this.titolo.score);
      }
      const timeframe =
        this.params.score !== 'sentiment'
          ? this.checkFocusedTimeframe(this.params.time, 100)
          : this.params.time
            ? DateUtils.fromTo(this.params.time).period
            : 7;
      Promise.resolve().then(() => {
        this.onScoreFocus(
          'score',
          this.params.score,
          timeframe,
          scoreColor,
          false,
        );
      });
    } else if (
      this.alertScoreType &&
      this.titolo &&
      this.params &&
      ((this.params.focused_score &&
        this.params.focused_score !== this.customScore) ||
        (this.params.score && this.params.score !== this.customScore))
    ) {
      this.getAlert();
      this.getAlertEvents();
    }
  }

  getAlert() {
    if (this.alertScoreType) {
      this.newsScoreState
        .fetchScoreData(this.alertScoreType)
        .pipe(
          catchError(() =>
            of({ lastScore: null, trendType: null, trendValue: null }),
          ),
        )
        .subscribe((res) => {
          if (['bb'].includes(this.alertScoreType)) {
            this.alertScoreValue = {};
            this.alertScoreValue.score =
              res.lastScore !== null ? res.lastScore : null;
            this.alertScoreValue.trend_value =
              res.lastScore !== null ? res.trendValue : null;
            this.alertScoreValue.trend_type = res.trendType;
          } else {
            this.alertScoreValue =
              res.lastScore !== null ? Number(res.lastScore.toFixed(1)) : null;
          }
          let scoreColor = 'transparent';
          if (
            this.alertScoreType === 'sentiment' &&
            this.titolo.sentiment?.sentiment
          ) {
            scoreColor = this.colorpipe.transform(
              this.titolo.sentiment.sentiment,
            );
          } else if (
            ['bb'].includes(this.alertScoreType) &&
            this.alertScoreValue.trend_type
          ) {
            scoreColor =
              this.alertScoreValue.trend_type === 'bear'
                ? '#dd001a'
                : '#1e816c';
          } else if (
            this.alertScoreValue &&
            this.auth.getScoreType(this.alertScoreType) === 'pos'
          ) {
            scoreColor = this.colorpipeScore2.transform(this.alertScoreValue);
          } else if (this.alertScoreValue) {
            scoreColor = this.colorpipeScore.transform(this.alertScoreValue);
          }
          const timeframe =
            this.alertScoreType !== 'sentiment'
              ? this.checkFocusedTimeframe(this.params.time, 100)
              : this.params.time
                ? DateUtils.fromTo(this.params.time).period
                : 7;
          Promise.resolve().then(() => {
            this.onScoreFocus(
              'alert',
              this.alertScoreType,
              timeframe,
              scoreColor,
              false,
            );
          });
        });
    }
  }

  getAlertEvents() {
    if (this.alertScoreType === 'sentiment') {
      this.subEvents.fetchSubEventsList(this.params).subscribe((result) => {
        const resCopy = JSON.parse(JSON.stringify(result.events));
        this.setAlertEventsInfo(resCopy);
      });
    } else if (
      !(this.alertScoreType === 'sentiment') &&
      (!(this.alertScoreType === 'credit_risk') ||
        (this.alertScoreType === 'credit_risk' &&
          this.params.type &&
          (this.params.type === 'company' ||
            this.params.type === 'pne' ||
            ['industry', 'supersector', 'sector', 'subsector'].includes(
              this.params.type,
            )))) &&
      (this.routing.isFolio() ||
        (this.params.type &&
          (this.params.type === 'company' ||
            this.params.type === 'pne' ||
            ['industry', 'supersector', 'sector', 'subsector'].includes(
              this.params.type,
            ))) ||
        this.params.isin)
    ) {
      const time = this.checkFocusedTimeframe(this.params.time, 100);
      const alertScoreKey = ScoreUtilsService.resolveScoreKey(
        this.alertScoreType,
      );
      if (this.alertScoreType === 'credit_risk') {
        const scoreType = this.newsScoreState.resolveScoreType('credit_risk');
        this.newsScoreState.fetchScoreData(scoreType).subscribe((state) => {
          const sign =
            state.lastScore && state.lastScore > 0 ? 'neg' : undefined;
          this.dispatchTopEvents(alertScoreKey, time, sign).subscribe(
            (result) => this.setAlertEventsInfo(result),
          );
        });
      } else {
        this.dispatchTopEvents(alertScoreKey, time).subscribe((result) =>
          this.setAlertEventsInfo(result),
        );
      }
    }
  }

  getScore() {
    const supportsScore = this.newsScoreState.supportsScoreData(
      this.params.type,
      this.routing.isFolio(),
      !!this.params.isin,
    );

    if (
      this.titolo &&
      this.titolo.entity &&
      this.customScore &&
      this.customScore !== 'sentiment' &&
      supportsScore
    ) {
      if (['bb'].includes(this.customScore)) {
        // For BB, compute trend synchronously from parent-provided score
        // to avoid async overwrite with stale data on time changes
        if (this.titolo.score != null) {
          const { trendType, trendValue } = ScoreUtilsService.getBullBearTrend(
            this.titolo.score,
          );
          this.titolo = {
            ...this.titolo,
            trend_value: trendValue,
            trend_type: trendType,
          };
        } else {
          const scoreType = this.newsScoreState.resolveScoreType(
            this.customScore,
          );
          this.newsScoreState.fetchScoreData(scoreType).subscribe((state) => {
            this.titolo = {
              ...this.titolo,
              score: state.lastScore,
              trend_value: state.trendValue,
              trend_type: state.trendType,
            };
          });
        }
      } else {
        const scoreType = this.newsScoreState.resolveScoreType(
          this.customScore,
        );
        this.newsScoreState.fetchScoreData(scoreType).subscribe((state) => {
          this.titolo = {
            ...this.titolo,
            score:
              state.lastScore !== null
                ? Number(state.lastScore.toFixed(1))
                : null,
          };
        });
      }
    }
  }

  getScoreEvents() {
    if (this.customScore === 'sentiment') {
      this.subEvents
        .fetchSubEventsList(this.params)
        .pipe(
          catchError(() => {
            this.isLoadingEvents = false;
            return of(null);
          }),
        )
        .subscribe((result) => {
          const resCopy = JSON.parse(JSON.stringify(result.events));
          this.setScoreEventsInfo(resCopy);
        });
    } else if (
      !(this.customScore === 'sentiment') &&
      (!(this.customScore === 'credit_risk') ||
        (this.customScore === 'credit_risk' &&
          this.params.type &&
          (this.params.type === 'company' ||
            this.params.type === 'pne' ||
            ['industry', 'supersector', 'sector', 'subsector'].includes(
              this.params.type,
            )))) &&
      (this.routing.isFolio() ||
        (this.params.type &&
          (this.params.type === 'company' ||
            this.params.type === 'pne' ||
            ['industry', 'supersector', 'sector', 'subsector'].includes(
              this.params.type,
            ))) ||
        this.params.isin)
    ) {
      const time = this.checkFocusedTimeframe(this.params.time, 100);
      const scoreKey = ScoreUtilsService.resolveScoreKey(this.customScore);
      if (this.customScore === 'credit_risk') {
        const scoreType = this.newsScoreState.resolveScoreType('credit_risk');
        this.newsScoreState.fetchScoreData(scoreType).subscribe((state) => {
          const sign =
            state.lastScore && state.lastScore > 0 ? 'neg' : undefined;
          this.dispatchTopEvents(scoreKey, time, sign).subscribe((result) =>
            this.setScoreEventsInfo(result),
          );
        });
      } else {
        this.dispatchTopEvents(scoreKey, time).subscribe((result) =>
          this.setScoreEventsInfo(result),
        );
      }
    } else {
      this.isLoadingEvents = false;
    }
  }

  // Dispatches to ScoreEventsService for the right entity/portfolio + scoreLab/BB
  // permutation. Drops the legacy `relative_importance` second ranking — news-title
  // only renders `contrib_amount` (the `absolute_count` field).
  private dispatchTopEvents(
    scoreKey: string,
    time: string,
    sign?: 'neg',
  ): Observable<TopEventsResponse> {
    const target: TopEventsTarget = this.topEventsParams.resolveTarget();
    if (TopEventsParamsService.isBullBearScoreKey(scoreKey)) {
      const params = this.topEventsParams.buildBullBearRequest({ time });
      const req$ =
        target.kind === 'entity'
          ? this.scoreEventsService.getBullBearTopEvents(
              target.id,
              target.type,
              params,
            )
          : this.scoreEventsService.getPortfolioBullBearTopEvents(
              target.content,
              params,
            );
      return req$.pipe(
        catchError(() => {
          this.isLoadingEvents = false;
          return of({ top_events: [] });
        }),
      );
    }
    const params = this.topEventsParams.buildScoreLabRequest({
      scoreKey,
      time,
      topEventsSign: sign,
    });
    const req$ =
      target.kind === 'entity'
        ? this.scoreEventsService.getTopEvents(target.id, target.type, params)
        : this.scoreEventsService.getPortfolioTopEvents(target.content, params);
    return req$.pipe(
      catchError(() => {
        this.isLoadingEvents = false;
        return of({ top_events: [] });
      }),
    );
  }

  getFlagEvents(type) {
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      const timeOverride =
        type === 'warning' || (type === 'caution' && !this.checkLongTimeframe())
          ? this.params.time || null
          : this.checkFocusedTimeframe(this.params.time, 365);
      this.subEvents
        .fetchSubEventsList(this.params, timeOverride)
        .subscribe((result) => {
          const resCopy = JSON.parse(JSON.stringify(result.events));
          this.setFlagEventsInfo(resCopy, type);
        });
    } else {
      let time = null;
      if (type === 'warning') {
        time = this.checkFocusedTimeframe(this.params.time, 100);
      } else if (type === 'caution') {
        time = this.checkFocusedTimeframe(this.params.time, 465);
      }
      const flagScoreType = this.auth.scorelabSettings.defaultFlag.score_type;
      const flagScoreKey = ScoreUtilsService.resolveScoreKey(flagScoreType);
      if (flagScoreType === 'credit_risk') {
        const scoreType = this.newsScoreState.resolveScoreType('credit_risk');
        this.newsScoreState.fetchScoreData(scoreType).subscribe((state) => {
          const sign =
            state.lastScore && state.lastScore > 0 ? 'neg' : undefined;
          this.dispatchTopEvents(flagScoreKey, time, sign).subscribe((result) =>
            this.setFlagEventsInfo(result, type),
          );
        });
      } else {
        this.dispatchTopEvents(flagScoreKey, time).subscribe((result) =>
          this.setFlagEventsInfo(result, type),
        );
      }
    }
  }

  setAlertEventsInfo(scoreEventsObj) {
    this.alertEvents = JSON.parse(JSON.stringify(scoreEventsObj));
    if (this.alertScoreType === 'sentiment') {
      let count = 0;
      scoreEventsObj.forEach((event) => {
        count += event.count;
      });
      this.alertEventsCount = count;
      this.alertEventsTimeframe = this.params.time
        ? DateUtils.fromTo(this.params.time).period
        : 7;
    } else {
      let count = 0;
      scoreEventsObj.top_events?.forEach((event) => {
        count += event.contrib_amount;
      });
      this.alertEventsCount = count;
      this.alertEventsTimeframe = DateUtils.fromTo(
        this.checkFocusedTimeframe(this.params.time, 100),
      ).period;
    }
  }

  setScoreEventsInfo(scoreEventsObj) {
    this.scoreEvents = JSON.parse(JSON.stringify(scoreEventsObj));
    if (this.customScore === 'sentiment') {
      let count = 0;
      scoreEventsObj.forEach((event) => {
        count += event.count;
      });
      this.scoreEventsCount = count;
      this.scoreEventsTimeframe = this.params.time
        ? DateUtils.fromTo(this.params.time).period
        : 7;
    } else {
      let count = 0;
      scoreEventsObj.top_events?.forEach((event) => {
        count += event.contrib_amount;
      });
      this.scoreEventsCount = count;
      this.scoreEventsTimeframe = DateUtils.fromTo(
        this.checkFocusedTimeframe(this.params.time, 100),
      ).period;
    }
    this.isLoadingEvents = false;
  }

  setFlagEventsInfo(flagEventsObj, flagType) {
    if (flagType === 'warning') {
      this.flagWarningEvents = JSON.parse(JSON.stringify(flagEventsObj));
    } else if (flagType === 'caution') {
      this.flagCautionEvents = JSON.parse(JSON.stringify(flagEventsObj));
    }
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      let count = 0;
      flagEventsObj.forEach((event) => {
        count += event.count;
      });
      if (flagType === 'warning') {
        this.flagWarningEventsCount = count;
        this.flagWarningEventsTimeframe = this.params.time
          ? DateUtils.fromTo(this.params.time).period
          : 7;
      } else if (flagType === 'caution') {
        this.flagCautionEventsCount = count;
        this.flagCautionEventsTimeframe = this.checkLongTimeframe()
          ? this.checkFocusedTimeframe(this.params.time, 365)
          : this.params.time
            ? DateUtils.fromTo(this.params.time).period
            : 7;
      }
    } else {
      let count = 0;
      flagEventsObj.top_events?.forEach((event) => {
        count += event.contrib_amount;
      });
      if (flagType === 'warning') {
        this.flagWarningEventsCount = count;
      } else if (flagType === 'caution') {
        this.flagCautionEventsCount = count;
      }
      if (flagType === 'warning') {
        this.flagWarningEventsTimeframe = DateUtils.fromTo(
          this.checkFocusedTimeframe(this.params.time, 100),
        ).period;
      } else if (flagType === 'caution') {
        this.flagCautionEventsTimeframe = DateUtils.fromTo(
          this.checkFocusedTimeframe(this.params.time, 465),
        ).period;
      }
    }
  }

  getIndustryBenchmark() {
    if (
      [
        'esg',
        'eb_sim',
        'eb_sim_risk',
        'general_risk',
        'esg_risk',
        'immediate_risk',
        'credit_risk',
        'bb',
      ].includes(this.customScore) &&
      this.params &&
      this.params.type === 'company'
    ) {
      this.yukkApi
        .scoresTimeSeries(
          'score',
          Object.assign({}, this.params, {
            requestScore: this.customScore,
            industry_bench: true,
          }),
          'chart',
        )
        .pipe(catchError(() => of({ score_ts_last_score: { score: null } })))
        .subscribe((res) => {
          let industry = 'Industry';
          if (this.titolo?.entity?.description?.Industry) {
            industry = this.titolo.entity.description.Industry.name;
          }
          this.industryBenchmarkScore = res.score_ts_last_score.score;
          if (res.score_ts_last_score.score === 0.0) {
            this.industryBenchmarkDescription = 'Laggard';
          } else if (res.score_ts_last_score.score === 1.0) {
            this.industryBenchmarkDescription = 'Below average';
          } else if (res.score_ts_last_score.score === 2.0) {
            this.industryBenchmarkDescription = 'Above average';
          } else if (res.score_ts_last_score.score === 3.0) {
            this.industryBenchmarkDescription = 'Leader';
          }
          this.industryBenchmarkDescription += ' in ' + industry;
        });
    } else {
      this.industryBenchmarkScore = null;
      this.industryBenchmarkDescription = '';
    }
  }

  checkWarningFlag() {
    if (
      this.titolo &&
      this.titolo.entity &&
      this.auth.scorelabSettings.defaultFlag &&
      this.auth.scorelabSettings.defaultFlag.entity_type.includes(
        this.titolo.entity.type,
      )
    ) {
      if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
        const currentScore = this.titolo.sentiment.sentiment * 100;
        if (currentScore) {
          this.flagScore = currentScore;
          if (
            this.auth.scorelabSettings.defaultFlag.threshold_setting ===
            'ABOVE_EQUAL'
          ) {
            if (
              currentScore >= this.auth.scorelabSettings.defaultFlag.threshold
            ) {
              this.showWarningFlag = true;
              this.auth.showWarningFlag = true;
              this.getFlagEvents('warning');
            } else {
              this.showWarningFlag = false;
              this.auth.showWarningFlag = false;
            }
          } else if (
            this.auth.scorelabSettings.defaultFlag.threshold_setting ===
            'BELOW_EQUAL'
          ) {
            if (
              currentScore <= this.auth.scorelabSettings.defaultFlag.threshold
            ) {
              this.showWarningFlag = true;
              this.auth.showWarningFlag = true;
              this.getFlagEvents('warning');
            } else {
              this.showWarningFlag = false;
              this.auth.showWarningFlag = false;
            }
          }
        } else {
          this.showWarningFlag = false;
          this.auth.showWarningFlag = false;
        }
      } else if (this.auth.scorelabSettings.defaultFlag.score_type) {
        const flagScoreType = this.newsScoreState.resolveScoreType(
          this.auth.scorelabSettings.defaultFlag.score_type,
        );
        this.newsScoreState.fetchScoreData(flagScoreType).subscribe((state) => {
          const currentScore = state.lastScore;
          if (currentScore) {
            this.flagScore = currentScore;
            if (
              this.auth.scorelabSettings.defaultFlag.threshold_setting ===
              'ABOVE_EQUAL'
            ) {
              if (
                currentScore >= this.auth.scorelabSettings.defaultFlag.threshold
              ) {
                this.showWarningFlag = true;
                this.auth.showWarningFlag = true;
                this.getFlagEvents('warning');
              } else {
                this.showWarningFlag = false;
                this.auth.showWarningFlag = false;
              }
            } else if (
              this.auth.scorelabSettings.defaultFlag.threshold_setting ===
              'BELOW_EQUAL'
            ) {
              if (
                currentScore <= this.auth.scorelabSettings.defaultFlag.threshold
              ) {
                this.showWarningFlag = true;
                this.auth.showWarningFlag = true;
                this.getFlagEvents('warning');
              } else {
                this.showWarningFlag = false;
                this.auth.showWarningFlag = false;
              }
            }
          } else {
            this.showWarningFlag = false;
            this.auth.showWarningFlag = false;
          }
        });
      } else {
        this.showWarningFlag = false;
        this.auth.showWarningFlag = false;
      }
    } else {
      this.showWarningFlag = false;
      this.auth.showWarningFlag = false;
    }
  }

  checkCautionFlag() {
    if (
      this.titolo &&
      this.titolo.entity &&
      this.auth.scorelabSettings.defaultFlag &&
      this.auth.scorelabSettings.defaultFlag.entity_type.includes(
        this.titolo.entity.type,
      )
    ) {
      if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
        const cautionTime = this.checkLongTimeframe()
          ? this.checkFocusedTimeframe(this.params.time, 365)
          : this.params.time
            ? this.params.time
            : null;
        const sentimentPeriod = this.params.period
          ? Number(this.params.period)
          : 7;
        this.newsScoreState
          .fetchSentimentDataWithTime(sentimentPeriod, cautionTime)
          .subscribe((state) => {
            let thresholdReached = false;
            state.quotientData.forEach((item) => {
              const currentScore = item.quotient * 100;
              if (currentScore) {
                if (
                  this.auth.scorelabSettings.defaultFlag.threshold_setting ===
                  'ABOVE_EQUAL'
                ) {
                  if (
                    currentScore >=
                    this.auth.scorelabSettings.defaultFlag.threshold
                  ) {
                    thresholdReached = true;
                  }
                } else if (
                  this.auth.scorelabSettings.defaultFlag.threshold_setting ===
                  'BELOW_EQUAL'
                ) {
                  if (
                    currentScore <=
                    this.auth.scorelabSettings.defaultFlag.threshold
                  ) {
                    thresholdReached = true;
                  }
                }
              }
            });
            if (thresholdReached) {
              this.showCautionFlag = true;
              this.auth.showCautionFlag = true;
              this.getFlagEvents('caution');
            } else {
              this.showCautionFlag = false;
              this.auth.showCautionFlag = false;
            }
          });
      } else if (this.auth.scorelabSettings.defaultFlag.score_type) {
        const flagScoreType = this.newsScoreState.resolveScoreType(
          this.auth.scorelabSettings.defaultFlag.score_type,
        );
        const cautionTime = this.checkFocusedTimeframe(this.params.time, 365);
        this.newsScoreState
          .fetchScoreDataWithTime(flagScoreType, cautionTime)
          .subscribe((state) => {
            let thresholdReached = false;
            state.scoreData.forEach((item) => {
              const currentScore = item.score;
              if (currentScore) {
                if (
                  this.auth.scorelabSettings.defaultFlag.threshold_setting ===
                  'ABOVE_EQUAL'
                ) {
                  if (
                    currentScore >=
                    this.auth.scorelabSettings.defaultFlag.threshold
                  ) {
                    thresholdReached = true;
                  }
                } else if (
                  this.auth.scorelabSettings.defaultFlag.threshold_setting ===
                  'BELOW_EQUAL'
                ) {
                  if (
                    currentScore <=
                    this.auth.scorelabSettings.defaultFlag.threshold
                  ) {
                    thresholdReached = true;
                  }
                }
              }
            });
            if (thresholdReached) {
              this.showCautionFlag = true;
              this.auth.showCautionFlag = true;
              this.getFlagEvents('caution');
            } else {
              this.showCautionFlag = false;
              this.auth.showCautionFlag = false;
            }
          });
      } else {
        this.showCautionFlag = false;
        this.auth.showCautionFlag = false;
      }
    } else {
      this.showCautionFlag = false;
      this.auth.showCautionFlag = false;
    }
  }

  getFlagTooltip(type) {
    const threshold = this.auth.scorelabSettings.defaultFlag.threshold;
    const scoreName = this.auth.getScoresInfo(
      this.auth.scorelabSettings.defaultFlag.score_type,
    )['full'];
    let score;
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      score = this.flagScore + ' of the ' + scoreName;
    } else {
      score = this.flagScore?.toFixed(2);
    }
    let tooltip = '';
    if (this.auth.scorelabSettings.defaultFlag.score_type === 'sentiment') {
      if (type === 'warning') {
        tooltip =
          'Current value ' +
          score +
          ' crossed the set threshold of ' +
          threshold +
          '.';
      } else if (type === 'caution') {
        tooltip =
          'One of the ' +
          scoreName +
          ' values in the past year crossed the set threshold of ' +
          threshold +
          '.';
      }
    } else {
      if (type === 'warning') {
        tooltip =
          'One or more of the events associated with ' +
          scoreName +
          ' occurred in the past 100 days. Current value ' +
          score +
          ' crossed the set threshold of ' +
          threshold +
          '.';
      } else if (type === 'caution') {
        tooltip =
          'One or more of the events associated with ' +
          scoreName +
          ' occurred in the past 465 days. One of the values in the past year crossed the set threshold of ' +
          threshold +
          '.';
      }
    }
    return {
      tooltip: tooltip,
      score_type: this.auth.scorelabSettings.defaultFlag.score_type,
      score_name: this.auth.getScoresInfo(
        this.auth.scorelabSettings.defaultFlag.score_type,
      )['name'],
      score_threshold:
        this.auth.scorelabSettings.defaultFlag.threshold_setting ===
        'ABOVE_EQUAL'
          ? 'High'
          : 'Low',
    };
  }

  displayFn(element) {
    return element && element.name ? element.name : '';
  }

  elementMatches(options, value) {
    const filterValue = value.toLowerCase();
    return options.filter((item) =>
      item.name.toLowerCase().includes(filterValue),
    );
  }

  inAverage() {
    if (this.period > 200) {
      this.period = 200;
    }
    if (this.period < 1) {
      this.period = 1;
    }
    this.router.navigate([], {
      queryParams: {
        period: this.period,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  select(item) {
    if (item === 'overall') {
      if (this.routing.isFolio()) {
        this.titolo.entity.type = 'Portfolio';
        this.titolo.entity.name = this.folio.name;
        this.router.navigate([], {
          queryParams: {
            id: this.params.portfolioId
              ? this.params.portfolioId
              : this.params.id,
            type: null,
            newstype:
              this.params.newstype === 'Events'
                ? 'Chronological'
                : this.params.newstype,
            portfolioId: null,
            eventid: null,
            score: null,
            time: this.params.score ? null : this.params.time,
            reflow: Math.random(),
            focused_score: this.customScore ? this.customScore : null,
          },
          queryParamsHandling: 'merge',
        });
      } else if (this.routing.isQuery()) {
        this.titolo.entity.type = 'Collection';
        this.titolo.entity.name = this.query.name;
        this.router.navigate([], {
          queryParams: {
            id: this.params.groupId,
            newstype: this.params.newstype,
            groupId: this.params.groupId,
            reflow: Math.random(),
          },
          queryParamsHandling: 'merge',
        });
      }
    } else {
      if (this.routing.isFolio()) {
        this.titolo.entity.type = item.type;
        this.titolo.entity.name = item.name;

        const newParams = {
          id: item.alpha_id,
          type: item.type,
          newstype: this.params.newstype,
          eventid: null,
          portfolioId: this.params.portfolioId
            ? this.params.portfolioId
            : this.params.id,
          score: this.isScoreFocused ? this.customScore : null,
          time: this.isScoreFocused ? 100 : this.params.time,
          reflow: Math.random(),
          focused_score: this.isScoreFocused ? this.customScore : null,
        };
        this.router.navigate([], {
          queryParams: newParams,
          queryParamsHandling: 'merge',
        });
      } else if (this.routing.isQuery()) {
        this.titolo.entity.type = 'Query';
        this.titolo.entity.name = item.name;
        this.router.navigate([], {
          queryParams: {
            id: item.uid,
            newstype: this.params.newstype,
            groupId: this.params.groupId,
            reflow: Math.random(),
          },
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  onScoreFocus(type, score, timeframe, element, onClick) {
    if (
      !this.isScoreFocused ||
      (this.params && this.params.score && score !== this.params.score)
    ) {
      let focusedColor = 'transparent';
      if (typeof element === 'string') {
        focusedColor = element;
      } else if (element) {
        focusedColor = window
          .getComputedStyle(element)
          .getPropertyValue('border-bottom-color');
      }
      this.userState.scoreFocusedColor = focusedColor;
      this.userState.scoreFocusedTimeframe = timeframe;
      this.scoreFocusedEventsService.setTimeframe(String(timeframe));
      if (type === 'score') {
        this.userState.scoreFocusedTopEvents = this.scoreEvents;
      } else if (type === 'warning') {
        this.userState.scoreFocusedTopEvents = this.flagWarningEvents;
      } else if (type === 'caution') {
        this.userState.scoreFocusedTopEvents = this.flagCautionEvents;
      } else if (type === 'alert') {
        this.userState.scoreFocusedTopEvents = this.alertEvents;
      }
      this.userState.scoreFocusedType = type;
      this.isScoreFocused = true;

      this.router.navigate([], {
        queryParams: {
          focused_score: null,
          score: score,
          time: timeframe,
          reflow: Math.random(),
        },
        queryParamsHandling: 'merge',
      });
    } else if (
      !onClick &&
      this.isScoreFocused &&
      this.params &&
      this.params.score &&
      score === this.params.score &&
      this.params.time &&
      this.checkFocusedTimeframe(this.params.time, null)
    ) {
      let focusedColor = 'transparent';
      if (typeof element === 'string') {
        focusedColor = element;
      } else if (element) {
        focusedColor = window
          .getComputedStyle(element)
          .getPropertyValue('border-bottom-color');
      }
      this.userState.scoreFocusedColor = focusedColor;
      this.userState.scoreFocusedTimeframe = this.checkFocusedTimeframe(
        this.params.time,
        null,
      );
      this.scoreFocusedEventsService.setTimeframe(
        String(this.userState.scoreFocusedTimeframe),
      );
      if (type === 'score') {
        this.userState.scoreFocusedTopEvents = this.scoreEvents;
      } else if (type === 'warning') {
        this.userState.scoreFocusedTopEvents = this.flagWarningEvents;
      } else if (type === 'caution') {
        this.userState.scoreFocusedTopEvents = this.flagCautionEvents;
      } else if (type === 'alert') {
        this.userState.scoreFocusedTopEvents = this.alertEvents;
      }
      this.userState.scoreFocusedType = type;
      this.isScoreFocused = true;
    } else {
      this.userState.scoreFocusedColor = 'transparent';
      this.userState.scoreFocusedTimeframe = null;
      this.scoreFocusedEventsService.clear();
      this.userState.scoreFocusedTopEvents = null;
      this.userState.scoreFocusedType = null;
      this.isScoreFocused = false;
      this.router.navigate([], {
        queryParams: {
          score: null,
          time: null,
          reflow: Math.random(),
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  appendItem(option) {
    if (this.routing.isMarket()) {
      this.dialog.open(PortfolioNameComponent, {
        data: {
          action: option,
          entity: this.titolo.entity,
        },
      });
    }
    if (this.routing.isSearch()) {
      this.dialog.open(QueryNameComponent, {
        data: {
          action: option,
          query: this.titolo.entity,
        },
      });
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  checkTimeframe() {
    if (this.params.time) {
      const days = DateUtils.fromTo(this.params.time).period;
      if (days < 100) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkLongTimeframe() {
    if (this.params.time) {
      const days = DateUtils.fromTo(this.params.time).period;
      if (days < 365) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkFocusedTimeframe(time, timeframe) {
    let days = null;
    if (time) {
      days = DateUtils.fromTo(time).period;
    }
    if (this.params?.score && ['sentiment'].includes(this.params.score)) {
      if (days) {
        return time;
      } else {
        return 7;
      }
    } else if (days === 100) {
      return time;
    } else if (days === 365) {
      return time;
    } else if (days === 465) {
      return time;
    } else if (timeframe === 100) {
      return 100;
    } else if (timeframe === 365) {
      return 365;
    } else if (timeframe === 465) {
      return 465;
    } else {
      return null;
    }
  }

  openDialog(entity) {
    this.dialog.open(DialogTableComponent, {
      data: {
        title: 'Sanctions on ' + entity.name,
        table: entity.sanctions.map((sanction: any) => ({
          authority: sanction.sanctioned_by.name,
          authorityId: sanction.sanctioned_by.alpha_id,
          authorityType: sanction.sanctioned_by.type,
          program: sanction.program,
          start: sanction.sanctioned_from,
          end: sanction.sanctioned_to,
        })),
      },
      width: '60%',
    });
  }
}
